export default {"src":"/_next/static/media/ra-aircraft-outline.37e396f7.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};